export default "__VITE_ASSET__C0BAnRf___"